export default {
    'Email': 'Email',
    'Email Placeholder': 'Электрондық поштаңызды енгізіңіз',
    'Back to login': 'Авторизация дегенге қайта келу',
    'Restore Password Text': 'Құпия сөзді қалпына келтіру үшін электрондық пошта мекенжайын енгізіңіз',
    'Restore Password Button': 'Құпия сөзді қалпына келтіру',
    'Timezone': 'Сағаттық белдеу',
    'Avatar': 'Аватар',
    'SystemDefaultLanguage': 'Жүйенің әдепкі тілі',
    'Name': 'Аты',
    'Surname': 'Тегі',
    'Save Changes': 'Өзгерістерді сақтау',
    'restoreStatusTextFirst': 'Құпия сөзді қалпына келтіру сұрауы жіберілді.',
    'restoreStatusTextSecond': 'Сізге жақын арада электрондық хат келеді.',
    'restoreStatusTextErrorFirst': 'Бұл электрондық пошта мекенжайын таба алмадық.',
    'restoreStatusTextErrorSecond': 'Енгізілген деректерді тексеріп, әрекетті қайталаңыз.',
    'New Password Title': 'Құпия сөзді қалпына келтіру',
    'New Password': 'Жаңа пароль',
    'Confirm new password': 'Құпия сөзді қайталаңыз',
    'New Password Placeholder': 'Жаңа құпия сөзді енгізіңіз',
}
